import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchDemographicsRequest,
  fetchDemographicsSuccess,
  fetchDemographicsFailure,
} from '../slices/demographicsSlice';
import type { DemographicsResponse } from '../../components/demographics/types';

function* fetchDemographicsSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${ENDPOINTS.location_demographics}/${restaurantId}`;
    const response = yield call(axios.get, url);

    const data: DemographicsResponse = response.data;
    
    if (data.data && data.data.length > 0) {
      yield put(fetchDemographicsSuccess(data.data[0]));
    } else {
      yield put(fetchDemographicsFailure('No demographics data found'));
    }
  } catch (error: any) {
    yield put(
      fetchDemographicsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch demographics'
      )
    );
  }
}

export function* demographicsSaga() {
  yield takeLatest(fetchDemographicsRequest.type, fetchDemographicsSaga);
}
